import { useRecoilState, useRecoilValue } from 'recoil';
import {
  // Trade settings
  timeSelectorAtom,
  tradeSizeAtom,
  activePoolObjAtom,
  assetSelectorPoolAtom,
  tradeTypeAtom,
  limitOrderStrikeAtom,
  LimitOrderPayoutAtom,
  // Market data
  pinnedMarketsAtom,
  favouriteMarketsAtom,
  favouritePerpsMarketsAtom,
  categoriesAtom,
  searchBarAtom,
  radioValueAtom,
  // UI state
  isTableShownAtom,
  selectedOrderToEditAtom,
  visualizeddAtom,
  ForexTimingsModalAtom,
  showOnboardingAnimationAtom,
  queuets2priceAtom,
  closeLoadingAtom,
  // Share modal
  ShareStateAtom,
  ShareBetAtom,
  approveModalAtom,
  // Pagination
  historyTableActivePage,
  cancelTableActivePage,
  platformActiveTableActivePage,
  platformHistoryTableActivePage,
  platformCancelTableActivePage,
  // Trade inspection
  tradeInspectMobileAtom,
  closeConfirmationModalAtom,
  rerenderPositionAtom,
  buyPriceAtom,
  sellPriceAtom,
  // User education
  isUserEducatedAtom,
  // Chart settings
  chartNumberAtom,
  chartControlsSettingsAtom,
} from '../atoms/tradeAtoms';
import { HHMMToSeconds } from '../atoms/tradeAtoms';

// Time selector hook
export function useTimeSelector() {
  const [timeSelector, setTimeSelector] = useRecoilState(timeSelectorAtom);

  const updateTimeSelector = (update: string) => {
    setTimeSelector({ HHMM: update, seconds: HHMMToSeconds(update) });
  };

  return [timeSelector, updateTimeSelector] as const;
}

// Trade size hook
export function useTradeSize() {
  return useRecoilState(tradeSizeAtom);
}

// Active pool object hook
export function useActivePoolObj() {
  return useRecoilState(activePoolObjAtom);
}

// Asset selector pool hook
export function useAssetSelectorPool() {
  return useRecoilState(assetSelectorPoolAtom);
}

// Trade type hook
export function useTradeType() {
  return useRecoilState(tradeTypeAtom);
}

// Limit order strike hook
export function useLimitOrderStrike() {
  return useRecoilState(limitOrderStrikeAtom);
}

// Limit order payout hook
export function useLimitOrderPayout() {
  return useRecoilState(LimitOrderPayoutAtom);
}

// Table visibility hook
export function useTableVisibility() {
  return useRecoilState(isTableShownAtom);
}

// Selected order to edit hook
export function useSelectedOrderToEdit() {
  return useRecoilState(selectedOrderToEditAtom);
}

// Visualized data hook
export function useVisualizedData() {
  return useRecoilState(visualizeddAtom);
}

// Forex timings modal hook
export function useForexTimingsModal() {
  return useRecoilState(ForexTimingsModalAtom);
}

// Onboarding animation hook
export function useOnboardingAnimation() {
  return useRecoilState(showOnboardingAnimationAtom);
}

// Queue TS to price hook
export function useQueueTs2Price() {
  return useRecoilState(queuets2priceAtom);
}

// Close loading hook
export function useCloseLoading() {
  return useRecoilState(closeLoadingAtom);
}

// Share modal hooks
export function useShareState() {
  const [shareState, setShareState] = useRecoilState(ShareStateAtom);

  const updateShareState = (update: boolean) => {
    setShareState({ isOpen: update });
  };

  return [shareState, updateShareState] as const;
}

export function useShareBet() {
  return useRecoilState(ShareBetAtom);
}

// Approve modal hook
export function useApproveModal() {
  return useRecoilState(approveModalAtom);
}

// Pagination hooks
export function useHistoryTablePage() {
  return useRecoilState(historyTableActivePage);
}

export function useCancelTablePage() {
  return useRecoilState(cancelTableActivePage);
}

export function usePlatformActiveTablePage() {
  return useRecoilState(platformActiveTableActivePage);
}

export function usePlatformHistoryTablePage() {
  return useRecoilState(platformHistoryTableActivePage);
}

export function usePlatformCancelTablePage() {
  return useRecoilState(platformCancelTableActivePage);
}

// Trade inspect mobile hook
export function useTradeInspectMobile() {
  return useRecoilState(tradeInspectMobileAtom);
}

// Close confirmation modal hook
export function useCloseConfirmationModal() {
  return useRecoilState(closeConfirmationModalAtom);
}

// Rerender position hook
export function useRerenderPosition() {
  return useRecoilState(rerenderPositionAtom);
}

export function useBuyPrice() {
  return useRecoilState(buyPriceAtom);
}

export function useSellPrice() {
  return useRecoilState(sellPriceAtom);
}

// User education hook
export function useUserEducation() {
  return useRecoilState(isUserEducatedAtom);
}

// Chart settings hooks
export function useChartNumber() {
  return useRecoilState(chartNumberAtom);
}

export function useChartControlsSettings() {
  return useRecoilState(chartControlsSettingsAtom);
}

// Market data hooks
export function usePinnedMarkets() {
  return useRecoilState(pinnedMarketsAtom);
}

export function useFavouriteMarkets() {
  return useRecoilState(favouriteMarketsAtom);
}

export function useFavouritePerpsMarkets() {
  return useRecoilState(favouritePerpsMarketsAtom);
}

export function useCategories() {
  return useRecoilState(categoriesAtom);
}

export function useSearchBar() {
  return useRecoilState(searchBarAtom);
}

export function useRadioValue() {
  return useRecoilState(radioValueAtom);
}

export function useChartNumberValue() {
  return useRecoilValue(chartNumberAtom);
}

export function useIsTableShown() {
  return useRecoilValue(isTableShownAtom);
}

export function useChartControlsSettingsValue() {
  return useRecoilValue(chartControlsSettingsAtom);
}
